import { useQuery } from '@apollo/client/react'
import { useSplitEnabled } from '@buffer-mono/features'

import { graphql } from '~publish/graphql'
import type { ResultOf, VariablesOf } from '~publish/graphql'

import { PostCard_Post } from '~publish/components/PostCard/fragments/PostCard_Post'
import { COLLABORATION_NOTES_SPLIT } from '~publish/components/PostDialogs/PostDetailsContent/useCollaborationNotesPanel'
import { PostUnreadMentionCount } from '~publish/hooks/notes/fragments/PostUnreadMentionCount'
import { PostUnreadNoteCount } from '~publish/hooks/notes/fragments/PostUnreadNoteCount'

export const GetPostGroupForPostGroupDetails = graphql(
  `
    query GetPostGroupForPostGroupDetails(
      $id: PostGroupId!
      $includeNotesSummary: Boolean! = false
    ) {
      postGroup(input: { id: $id }) {
        id
        posts {
          id
          ...PostCard_Post
          ...PostUnreadNoteCount @include(if: $includeNotesSummary)
          ...PostUnreadMentionCount @include(if: $includeNotesSummary)
        }
      }
    }
  `,
  [PostCard_Post, PostUnreadNoteCount, PostUnreadMentionCount],
)

type UseQueryResponse = ReturnType<
  typeof useQuery<
    ResultOf<typeof GetPostGroupForPostGroupDetails>,
    VariablesOf<typeof GetPostGroupForPostGroupDetails>
  >
>

export const useLoadPostGroup = (id: string): UseQueryResponse => {
  const { isReady, isEnabled } = useSplitEnabled(COLLABORATION_NOTES_SPLIT)
  return useQuery(GetPostGroupForPostGroupDetails, {
    variables: { id, includeNotesSummary: isReady && isEnabled },
    errorPolicy: 'all',
  })
}
